export const isVisible = (el: HTMLElement | null) => {
    if (!el) return false;
    const style = getComputedStyle(el);
    return (
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        el.offsetParent !== null
    );
};

export const getEffectiveZIndex = (el: HTMLElement | null): number => {
    while (el && el !== document.body) {
        const style = getComputedStyle(el);
        const zIndex = style.zIndex;

        if (zIndex !== "auto" && !isNaN(parseInt(zIndex))) {
            return parseInt(zIndex, 10);
        }

        el = el.parentElement;
    }

    return 0; 
};
